<template>
  <div class="menu-content">
    <ul class="side-menu">
      <li @click="onMenuClick(1)" :class="activeIndex == 1 ? 'active' : ''">
        链信云介绍<img src="../assets/right-icon.png" alt="" />
      </li>
      <li @click="onMenuClick(2)" :class="activeIndex == 2 ? 'active' : ''">
        链信云收费标准<img src="../assets/right-icon.png" alt="" />
      </li>
      <li @click="onMenuClick(4)" :class="activeIndex == 4 ? 'active' : ''">
        代币发行及配套服务<img src="../assets/right-icon.png" alt="" />
      </li>
      <li @click="onMenuClick(5)" :class="activeIndex == 5 ? 'active' : ''">
        数字钱包旗舰产品介绍<img src="../assets/right-icon.png" alt="" />
      </li>
    </ul>
    <div class="tg">
      <img src="../assets/tg-icon.png" alt="" /><a
        target="_blank"
        href="https://t.me/Topcredit017"
        >商务联系
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: [String, Number],
      default: function() {
        1;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onMenuClick(index) {
      this.activeIndex = index;
      if (index == 1) {
        this.$router.push({ path: "/" });
      } else if (index == 2) {
        this.$router.push({ path: "/cloudStandard" });
      } else if (index == 3) {
        this.$router.push({ path: "/topcreditbank" });
      } else if (index == 4) {
        this.$router.push({ path: "/supportService" });
      } else if (index == 5) {
        this.$router.push({ path: "/digitalWallet" });
      }
    }
  }
};
</script>

<style lang="scss">
.menu-content {
  .side-menu {
    padding: 0px;
    margin: 0 0px 15px;
    width: 210px;
    border-bottom: 1px solid #e7e7e7;
    li {
      list-style: none;
      cursor: pointer;
      padding: 0 10px;
      margin: 0px;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-weight: 500;
      margin: 8px 0px 8px 10px;
      text-align: left;
      color: #354052;
      &.active {
        background-color: #ecf2f5;
      }
      img {
        width: 18px;
        height: 18px;
        float: right;
        text-align: right;
        line-height: 36px;
        vertical-align: middle;
        margin-top: 8px;
      }
    }
  }
  .tg {
    margin-left: 20px;
    cursor: pointer;
    text-align: left;
    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
    a {
      margin-left: 10px;
      vertical-align: middle;
      color: #354052;
      font-weight: 500;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sideMenu.vue